import type { Item, Vec2 } from '../hp/types';
import { isAttic } from './attic';

export interface LocalFootprint { minX: number; maxX: number; minZ: number; maxZ: number }
export type Footprints = ReadonlyMap<string, LocalFootprint>;

export function localFootprint(item: Item, footprints?: Footprints): LocalFootprint {
  const measured = footprints?.get(item.id);
  if (measured) return measured;
  // A mansard's position is its back edge on the wall; the rest are centred on theirs.
  return isAttic(item) ? { minX: -item.size.w / 2, maxX: item.size.w / 2, minZ: 0, maxZ: item.size.d }
    : { minX: -item.size.w / 2, maxX: item.size.w / 2, minZ: -item.size.d / 2, maxZ: item.size.d / 2 };
}

export function localToPlan(item: Item, u: number, v: number): Vec2 {
  const c = Math.cos(item.rotation), s = Math.sin(item.rotation);
  return { x: item.position.x + u * c - v * s, z: item.position.z + u * s + v * c };
}

export function itemFootprint(item: Item, footprints?: Footprints): [Vec2, Vec2, Vec2, Vec2] {
  const b = localFootprint(item, footprints);
  return [localToPlan(item, b.minX, b.minZ), localToPlan(item, b.maxX, b.minZ),
    localToPlan(item, b.maxX, b.maxZ), localToPlan(item, b.minX, b.maxZ)];
}

export function boundsOf(points: readonly Vec2[]): LocalFootprint {
  return { minX: Math.min(...points.map(p => p.x)), maxX: Math.max(...points.map(p => p.x)),
    minZ: Math.min(...points.map(p => p.z)), maxZ: Math.max(...points.map(p => p.z)) };
}
